import { isDemoMode } from '../tradingMode';
/**
 * 계좌 서비스 설정
 * 각 서비스(출금/이체/입금)의 메타데이터와 초기값을 관리합니다.
 */
export const SERVICE_CONFIG = {
    withdraw: {
        title: '출금신청',
        subTitle: '출금 신청하실 금액을 입력해주세요',
        buttonLabel: '출금 신청하기',
        requiredFields: ['accountPassword', 'depositAccount', 'bankCode'],
        initialData: () => ({
            withdrawalAccount: '',
            withdrawalAccountAlias: '',
            accountPassword: '',
            expectedProcessingTime: '영업일 기준 1~3일',
            withdrawalAmount: 0,
            depositAccount: '',
            fee: 0,
            bankCode: '',
        }),
    },
    transfer: {
        title: '이체금액 입력',
        subTitle: '이체하실 계좌와 금액을 입력해주세요',
        buttonLabel: '이체 신청하기',
        requiredFields: ['accountPassword', 'recipientAccount'],
        initialData: () => ({
            withdrawalAccount: '',
            withdrawalAccountAlias: '',
            recipientAccount: '',
            recipientAccountAlias: '',
            accountPassword: '',
            expectedProcessingTime: '영업일 기준 1~3일',
            transferAmount: 0,
            fee: 0,
            bankCode: '',
        }),
    },
    deposit: {
        title: '입금정보 입력',
        subTitle: '입금하신 정보를 정확히 입력해주세요',
        buttonLabel: '입금정보 입력완료',
        requiredFields: isDemoMode()
            ? ['depositAccount', 'accountPassword']
            : ['depositAccount', 'accountPassword', 'bankCode', 'transferStatement'],
        initialData: () => ({
            depositAccount: '',
            bankCode: '',
            mainTradingAccount: '',
            mainTradingAccountAlias: '',
            accountPassword: '',
            expectedProcessingTime: '영업일 기준 1~3일',
            depositAmount: 0,
            fee: 0,
            transferStatement: null,
        }),
    },
};
//# sourceMappingURL=accountService.js.map